import { useState, useCallback } from "react";
import { bulkUploadUsers } from "../../service/AdminService/userService";

export const useBulkUploadUsers = () => {
  const [bulkData, setBulkData] = useState(null);
  const [bulkLoading, setBulkLoading] = useState(false);
  const [bulkError, setBulkError] = useState(null);

  const addBulkUsers = useCallback(async (payload) => {
    setBulkLoading(true);
    setBulkError(null);

    try {
      const response = await bulkUploadUsers(payload);

      setBulkData(response);

      if (response?.status === "ERROR") {
        setBulkError(response?.message || "Validation failed");
      }

      return response;
    } catch (error) {
      const fallbackMessage =
        error?.message || "An unexpected error occurred during upload";
      setBulkError(fallbackMessage);
      throw error;
    } finally {
      setBulkLoading(false);
    }
  }, []);

  const resetBulkState = useCallback(() => {
    setBulkData(null);
    setBulkLoading(false);
    setBulkError(null);
  }, []);

  return {
    bulkData,
    bulkLoading,
    bulkError,
    addBulkUsers,
    resetBulkState,
  };
};